var map = {
	"./cake.webp": 2394,
	"./correct-ico.webp": 2395,
	"./crown-blue.webp": 2396,
	"./crown.webp": 2397,
	"./pocket.webp": 2398,
	"./present.webp": 2399,
	"./relegation.webp": 2400,
	"./t-deposit.webp": 2401,
	"./t-turnover.webp": 2402,
	"./vip-1.webp": 2403,
	"./vip-2.webp": 2404,
	"./vip-3.webp": 2405,
	"./vip-4.webp": 2406,
	"./vip-5.webp": 2407,
	"./vip-badge.webp": 2408,
	"./vip-bg.webp": 2409,
	"./vip-bonus-bg.webp": 2410,
	"./vip1.webp": 2411,
	"./vip2.webp": 2412,
	"./vip3.webp": 2413,
	"./vip4.webp": 2414,
	"./vip5.webp": 2415,
	"./vip6.webp": 2416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 396;